<div class="custom-date-picker-wrapper">
  <label *ngIf="label" class="custom-date-label">{{ label }}</label>
  
  <mat-form-field class="custom-date-field" [class.required]="isRequired" appearance="outline">
    <input 
      matInput 
      [matDatepicker]="picker"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [min]="minDate"
      [max]="maxDate"
      [formControl]="formControlInput"
      (dateChange)="onDateChange($event.value)"
      (click)="picker.open()"
      [ngClass]="classes"
    />
    
    <mat-datepicker-toggle matIconSuffix [for]="picker">
      <mat-icon matDatepickerToggleIcon>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      </mat-icon>
    </mat-datepicker-toggle>
    
    <mat-datepicker #picker touchUi="true"></mat-datepicker>
  </mat-form-field>
</div>